import type * as React from 'react';

interface ImageWrapperProps extends React.HTMLAttributes<HTMLDivElement>{
    src: string;
    alt: string;
}

export const ImageWrapper: React.FC<ImageWrapperProps> = (props) => {
    const { src, alt, ...divProps } = props;
    return (
        <div {...divProps}>
            <img
                style={{maxHeight: '100%', maxWidth: '100%'}}
                src={src}
                alt={alt}
            />
        </div>
    );
};